import { render, staticRenderFns } from "./refund-rule.vue?vue&type=template&id=36f3833e&scoped=true&"
import script from "./refund-rule.vue?vue&type=script&lang=js&"
export * from "./refund-rule.vue?vue&type=script&lang=js&"
import style0 from "./refund-rule.vue?vue&type=style&index=0&id=36f3833e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f3833e",
  null
  
)

export default component.exports